export default __webpack_public_path__ + "static/media/Tennessee-Court-logo.323efe25.png";